import React from "react";

export default function Contact() {
  return (
    <div className="contact">
      <div className="mid-text">
        {" "}
        <i>
          <b>Contact For Best DEALS</b>
        </i>
        <br />
      </div>
      <br />
      <div className="infoo">
        <big>
          <b>
            <span className="green">BD</span> TOUR
          </b>
        </big>{" "}
        <br />
        <br />
        <b>
          Address: 18/5 AhmedNagar, Mirpur #1, Dhaka
          <br />
          <br />
          Phone: +8801648885657, +8801965830984 <br />
          <br />
          Mail Address: bdTour_1971@gmail.com
        </b>
        <br />
        <br />
      </div>
    </div>
  );
}
